module.exports = __webpack_public_path__ + "assets/tx-active.4ec435c6.svg";